module.exports = __webpack_public_path__ + "img/megafon-logo-white.ba8698bd.svg";